import { flatten } from "lodash";
import { Task } from "../../shared/models/Task";
import { TaskDto } from "../service/api/TaskDto";
import { IntermediaryIdentityFromResponse } from "./IntermediaryIdentityFromResponse";
import { TaskAttributeFromResponse } from "./TaskAttributeFromResponse";
import { TaskTypeFromResponse } from "./TaskTypeFromResponse";
import { UserIdentityFromResponse } from "./UserIdentityFromResponse";
import { constants } from "shared/constants";
import { IntermediaryDisplayNameFromResponse } from "./IntermediaryDisplayNameFromResponse";

export class TaskFromResponse {
    constructor(private taskFromResponse: TaskDto) {}

    task(): Task {
        return {
            id: this.taskFromResponse.id,
            number: this.taskFromResponse.number,
            subject: this.taskFromResponse.subject,
            description: this.taskFromResponse.description,
            tags: flatten(
                this.taskFromResponse.attributeList
                    .filter((x) => x.code === "TAG_LIST")
                    .map((a) =>
                        Array.isArray(a.customValue.value)
                            ? a.customValue.value.map((v) => {
                                  return { color: v.flexField1, description: v.description };
                              })
                            : [{ color: a.customValue.value.flexField1, description: a.customValue.value.description }]
                    )
            ),
            implementedAction: new TaskAttributeFromResponse(
                this.taskFromResponse.attributeList,
                constants.attributeCodes.implementedAction
            ).taskAttributeMulti(),
            recommendedContactType:
                new TaskAttributeFromResponse(
                    this.taskFromResponse.attributeList,
                    "RECOMMENDED_CONTACT_TYPE"
                ).taskAttribute()?.action?.description ?? null,
            contactType: new TaskAttributeFromResponse(
                this.taskFromResponse.attributeList,
                "CONTACT_TYPE"
            ).taskAttribute(),
            diagnosis: new TaskAttributeFromResponse(
                this.taskFromResponse.attributeList,
                constants.attributeCodes.diagnosis
            ).taskAttributeMulti(),
            type: new TaskTypeFromResponse(this.taskFromResponse.taskType).taskType(),
            status: this.taskFromResponse.status,
            assignee: new UserIdentityFromResponse(this.taskFromResponse.assignee).userIdentity(),
            statusDate: new Date(this.taskFromResponse.statusDate),
            plannedDate: new Date(this.taskFromResponse.plannedDate),
            autoCloseAfter:
                this.taskFromResponse.autoCloseAfter !== null ? new Date(this.taskFromResponse.autoCloseAfter) : null,
            attachmentList: this.taskFromResponse.attachmentList,
            comments: this.taskFromResponse.commentList.map((comment) => {
                return {
                    id: comment.id,
                    author: new UserIdentityFromResponse(comment.author).userIdentity(),
                    commentDate: new Date(comment.commentDate),
                    content: comment.body,
                };
            }),
            intermediary: new IntermediaryIdentityFromResponse(
                this.taskFromResponse.intermediary
            ).intermediaryIdentity(),
            intermediaryDisplayName: new IntermediaryDisplayNameFromResponse(
                this.taskFromResponse.intermediary
            ).displayName(),
            externalReferenceId: this.taskFromResponse.externalReferenceId,
            sellerInformation: this.taskFromResponse.attributeList.find(
                (x) => x.code === constants.attributeCodes.sellerInformation
            )?.stringValue,
            operationList: this.taskFromResponse.operationList,
        };
    }
}
